// Local translations
export const T = {
  en_GB: {
    editTenant: "Edit Tenant",
    addNewTenant: "Add New Tenant",
    updateTenantInfo: "Update the tenant information below.",
    configureNewOrg: "Configure a new organization and its authentication method.",
    somethingWentWrong: "Something went wrong",
    failedToSaveTenant: "Failed to save tenant",
    organizationName: "Organization Name",
    slug: "Slug",
    slugPlaceholder: "acme-corp",
    slugHelp: "Unique identifier (lowercase letters, numbers, and hyphens only)",
    slugChangeTitle: "Changing the slug changes the organization's address",
    slugChangeRedirect: (old: string, days: string) =>
      `The old address “${old}” keeps redirecting to the new one and stays reserved for this organization for ${days} days.`,
    slugChangeSso: (days: string) =>
      `SSO keeps the current callback URL until a tenant administrator registers the new one in the identity provider and confirms it on the SSO settings page. After ${days} days SSO switches automatically and stops working if the identity provider has not been updated.`,
    slugChangeSessions: "Signed-in users are moved to the new address on their next page load.",
    slugChangeIntegrations: "Integrations that store launch URLs or the slug should be updated.",
    ownerPartner: "Owner (Partner)",
    noOwnerQuantfolio: "No owner (Quantfolio managed)",
    assignToPartner: "Assign this tenant to a partner for management",
    cancel: "Cancel",
    save: "Save",
    addTenant: "Add Tenant",
    orgNamePlaceholder: "Acme Corporation",
    subscriptionTier: "Subscription Tier",
    tierHelp: "Determines features and limits for this tenant",
    tierBasic: "Basic",
    tierBusiness: "Business",
    tierEnterprise: "Enterprise",
  },
  nb_NO: {
    editTenant: "Rediger organisasjon",
    addNewTenant: "Legg til ny organisasjon",
    updateTenantInfo: "Oppdater organisasjonsinformasjonen nedenfor.",
    configureNewOrg: "Konfigurer en ny organisasjon og autentiseringsmetode.",
    somethingWentWrong: "Noe gikk galt",
    failedToSaveTenant: "Kunne ikke lagre organisasjon",
    organizationName: "Organisasjonsnavn",
    slug: "Slug",
    slugPlaceholder: "acme-corp",
    slugHelp: "Unik identifikator (kun små bokstaver, tall og bindestreker)",
    slugChangeTitle: "Endring av slug endrer organisasjonens adresse",
    slugChangeRedirect: (old: string, days: string) =>
      `Den gamle adressen «${old}» videresender fortsatt til den nye og er reservert for denne organisasjonen i ${days} dager.`,
    slugChangeSso: (days: string) =>
      `SSO beholder den nåværende callback-URLen til en administrator hos organisasjonen har registrert den nye hos identitetsleverandøren og bekreftet på SSO-innstillingssiden. Etter ${days} dager byttes SSO automatisk og slutter å virke hvis identitetsleverandøren ikke er oppdatert.`,
    slugChangeSessions: "Innloggede brukere flyttes til den nye adressen ved neste sidelasting.",
    slugChangeIntegrations: "Integrasjoner som lagrer lenker eller slug bør oppdateres.",
    ownerPartner: "Eier (Partner)",
    noOwnerQuantfolio: "Ingen eier (Quantfolio-administrert)",
    assignToPartner: "Tildel denne organisasjonen til en partner for administrasjon",
    cancel: "Avbryt",
    save: "Lagre",
    addTenant: "Legg til organisasjon",
    orgNamePlaceholder: "Acme Corporation",
    subscriptionTier: "Abonnementsnivå",
    tierHelp: "Bestemmer funksjoner og grenser for denne organisasjonen",
    tierBasic: "Basic",
    tierBusiness: "Business",
    tierEnterprise: "Enterprise",
  },
} as const;
